import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import PageDetail from './pages/PageDetail'
import Error404 from './pages/Error404'
import Error403 from './pages/Error403'

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50 text-gray-800 antialiased">
      {/* Scroll restoration on route changes */}
      <ScrollToTop />

      {/* Header Navigation */}
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <Routes>
          {/* Forside */}
          <Route path="/" element={<Home />} />

          {/* Landbrugsmaskinstation */}
          <Route path="/landbrugsmaskinstation" element={<PageDetail />} />
          <Route path="/landbrugsmaskinstation/:subSlug" element={<PageDetail />} />

          {/* Entreprenør & Anlæg */}
          <Route path="/entreprenoer-og-anlaeg" element={<PageDetail />} />
          <Route path="/entreprenoer-og-anlaeg/:subSlug" element={<PageDetail />} />

          {/* Maskinudlejning / Salg */}
          <Route path="/maskinudlejning-salg" element={<PageDetail />} />
          <Route path="/maskinudlejning-salg/:subSlug" element={<PageDetail />} />

          {/* Om os & Galleri */}
          <Route path="/om-os-galleri" element={<PageDetail />} />
          <Route path="/om-os-galleri/historie" element={<PageDetail />} />
          <Route path="/om-os-galleri/etableringsstoette" element={<PageDetail />} />
          <Route path="/om-os-galleri/:subSlug" element={<PageDetail />} />
          {/* Redirect duplicate Maskinpark route to the canonical one */}
          <Route
            path="/om-os-galleri/maskinpark"
            element={<Navigate to="/maskinudlejning-salg/maskinpark" replace />}
          />

          {/* Salg af sand/sten og grus */}
          <Route path="/sand-sten-grus" element={<PageDetail />} />
          <Route path="/sand-sten-grus/:subSlug" element={<PageDetail />} />

          {/* Kontakt */}
          <Route path="/kontakt" element={<PageDetail />} />

          {/* Error Pages */}
          <Route path="/403" element={<Error403 />} />
          <Route path="/404" element={<Error404 />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default App
